module.exports = __webpack_public_path__ + "img/results-main-banner.9c3d44ea.png";